export default __webpack_public_path__ + "static/media/27t.6416092a.jpg";